/**
 * Gestion menu navbar + header
 */
export function handleNav() {
  // navbar toggler
  const toggleNav = function () {
    const nav = document.querySelector(this.getAttribute('data-trigger'))
    this.classList.toggle('open')
    document.body.classList.toggle('open')
    document.getElementById('header').classList.toggle('open')
    nav.classList.toggle('show')
    document.querySelector('.navbar-overlay').classList.toggle('visible')
  }
  document.querySelectorAll('[data-trigger]').forEach((el) => {
    el.addEventListener('click', toggleNav)
  })
}

/**
 * Sticky header
 */
export function sticky() {
  const h = document.getElementById('header'),
    s = 'sticky',
    w = document.querySelector('html')

  //if ((w.scrollTop > 64 && w.offsetWidth > bp) || (w.scrollTop > 80 && w.offsetWidth <= bp))
  if (h != null) {
    if (w.scrollTop > 100) h.classList.add(s)
    else h.classList.remove(s)
  }
}

/**
 * Reveal function
 */
export function reveal() {
  document.querySelectorAll('.reveal').forEach((el) => {
    const windowHeight = window.innerHeight
    const elementTop = el.getBoundingClientRect().top
    const elementVisible = 150
    if (elementTop < windowHeight - elementVisible) {
      el.classList.add('active')
    } else {
      el.classList.remove('active')
    }
  })
}
